export default __webpack_public_path__ + "static/media/bankwire.b4ff32e4.svg";